<template>
  <div class="container-fluid w-100 pb-3">
    <navbar :title="$t('spreader_data.generation_title')"/>
    <form class="no-margin" @submit.prevent="generateSpreaderData" @reset.prevent="onReset">
      <div class="row px-1">
        <div class="col-sm-6 px-2">
          <span class="span-title">
            {{ $t('ins_report.from_date') }}
          </span>
          <date-time-picker
            v-model:date="fromDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>

        <div class="col-sm-6 px-2">
          <span class="span-title">
            {{ $t('ins_report.to_date') }}
          </span>
          <date-time-picker
            v-model:date="toDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 nopads">
          <span class="span-title">
            {{ $t('users.company') }}
          </span>
            <select
                id="customer"
                v-model="company"
                class="form-select form-select-sm mb-3"
            >
                <option :value="null" disabled>
                    {{ $t('users.select_company') }}
                </option>
                <option v-for="c in companies" :key="c.id" :value="c.id">
                    {{ c.name }}
                </option>
            </select>
        </div>
      </div>
      <div class="col-sm-12 d-flex justify-content-end">
        <button class="btn btn-danger form-button" :disabled="!fromDate||!toDate||loading||!company" @click.stop="removerVisible = true">
          {{ $t('spreader_data.remove_data') }}
        </button>
        <button type="reset" class="btn btn-primary form-button">
          {{ $t('ins_report.clear') }}
        </button>
        <button type="submit" class="btn btn-success form-button" :disabled="!fromDate||!toDate||loading">
          {{ $t('daily_summary.generate') }}
        </button>
      </div>
    </form>

    <!-- Harja removal modal -->
    <base-modal
      v-if="removerVisible"
      :hide-footer="true"
      :hide-header-close="true"
      :title="$t('spreader_data.remove_external')"
    >
      <div class="row mb-2">
        <span>{{ $t('spreader_data.remove_all_text') }}</span>
      </div>
      <div class="col-12 text-right">
        <button class="btn btn-secondary form-button" @click="removerVisible = false">
          {{ $t('common.cancel') }}
        </button>
        <button class="btn btn-danger form-button" @click="submitRemoval">
          {{ $t('spreader_data.remove_data') }}
        </button>
      </div>
    </base-modal>


    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import DateTimePicker from "@/components/common/DateTimePicker";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'SpreaderDataGenerator',
    components: {BaseModal, Navbar, DateTimePicker },
    mixins: [restApi, timeUtils],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            fromDate: null,
            toDate: null,
            company: null,
            removerVisible: false,
            companies: []
        }
    },

    mounted() {
        this.fetchCompanies()
    },

    methods: {
        async fetchCompanies() {
            this.loading = true
            const { err, ...response } = await this.axios.get(this.companyUrl).catch((err) => ({err}));
            this.loading = false
            if (err) {
                // Do something
                return;
            }
            this.companies = response.data;
        },
        generateSpreaderData: function () {
            let params = {}
            if (this.fromDate) {
                params.from = this.fromDate
            }
            if (this.toDate) {
                params.to = this.toDate
            }
            if (this.fromDate > this.toDate) {
                this.showAlert(this.$t('daily_summary.invalid_date'))
                return undefined
            }
            if (this.company) {
                params.company = this.company
            }
            this.loading = true
            this.restFetchParams(this.generateSpreaderDataUrl, params, this.success, this.fail)
        },
        success: function () {
            this.loading = false
            this.showAlert(this.$t('spreader_data.generation_success'), 'success')
            this.$emit("closeModal")
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('spreader_data.generation_fail'))
        },
        onReset: function () {
            this.fromDate = null
            this.toDate = null
            this.company = null
        },
        submitRemoval() {
            let params = {}
            if (this.fromDate) {
                params.from = this.fromDate
            }
            if (this.toDate) {
                params.to = this.toDate
            }
            if (this.fromDate > this.toDate) {
                this.showAlert(this.$t('daily_summary.invalid_date'))
                return undefined
            }
            if (this.company) {
                params.company = this.company
            }
            this.loading = true
            this.removerVisible = false
            this.restAdd(this.removeSpreaderDataUrl, params, this.removeSuccess, this.removeFail)
        },
        removeSuccess: function () {
            this.loading = false
            this.showAlert(this.$t('spreader_data.removal_success'), 'success')
            this.$emit("closeModal")
        },
        removeFail: function () {
            this.loading = false
            this.showAlert(this.$t('spreader_data.removal_error'))
        }
    }
}
</script>
